var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSleeves0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 181,
    viewBox: "0 0 213 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_725_49769)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5866 6.20361C71.8085 5.42423 73.4213 5.42257 75.3327 5.91254C76.278 18.3256 88.0741 24.986 106.588 24.986C124.906 24.986 136.747 18.467 137.918 6.30527C139.024 5.73717 141.868 5.41858 143.251 6.47105C152.119 9.30948 161.048 12.32 168.7 14.8997C172.112 16.05 175.27 17.1146 178.055 18.0401C194.218 23.4115 203.937 68.1365 207.675 99.0211C203.119 103.514 190.351 109.06 165.839 109.06V181.001H106.5H47.3234V109.473C22.811 109.473 9.88124 103.514 5.3252 99.0211C9.06349 68.1365 18.7822 23.4115 34.9453 18.0401C37.7305 17.1146 40.8883 16.0499 44.3001 14.8997L44.3001 14.8997C52.1929 12.2387 61.4448 9.11956 70.5866 6.20361Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2077 20.8486C16.865 32.3761 8.68283 71.2811 5.3252 99.0208C9.59544 103.705 23.2239 110.039 47.5378 110.094C46.9359 87.9577 46.7433 54.237 48.4217 51.2714L48.4385 51.2421C47.4589 43.3839 41.0479 34.0318 35.4712 26.823C33.6355 24.45 31.7546 22.6885 30.2077 20.8486Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8548 119.723V120.263H47.8768C47.8695 120.085 47.8621 119.905 47.8548 119.723Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.484 20.6211C196.112 31.3709 204.483 70.6401 207.84 98.3798C203.57 103.064 189.942 109.398 165.628 109.453C166.23 87.3167 166.422 53.5961 164.744 50.6304L164.727 50.6011C165.707 42.7429 172.118 33.3908 177.694 26.182C179.53 23.8091 180.938 22.4609 182.484 20.6211Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.311 119.082V119.622H165.289C165.296 119.444 165.303 119.264 165.311 119.082Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5659 17.4138C45.3478 14.0558 56.9965 9.89546 70.3551 5.87002C71.1839 5.45778 73.7531 4.88064 75.7422 5.87C76.1566 13.2902 81.3008 18.9275 87.931 21.8131C79.3347 26.5888 59.3921 39.0729 48.3925 50.8035C46.7073 43.2555 36.7077 27.9238 29.9165 20.9757C31.6701 19.2276 33.5903 18.092 35.5659 17.4138Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.444 17.4138C167.662 14.0558 156.013 9.89546 142.655 5.87002C141.826 5.45778 139.257 4.88064 137.268 5.87C136.853 13.2902 131.709 18.9275 125.079 21.8131C133.675 26.5888 153.618 39.0729 164.617 50.8035C166.302 43.2555 176.302 27.9238 183.093 20.9757C181.34 19.2276 179.419 18.092 177.444 17.4138Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.6334 110.636C23.1621 110.636 9.60499 104.121 5.0566 99.5916C4.64239 97.5243 5.09118 93.4461 6.15521 91.2666C11.942 96.2857 29.3964 100.636 47.6334 101.155V110.636Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.425 109.928C189.896 109.928 203.128 104.909 207.676 100.38C208.505 98.7231 208.09 93.3379 206.847 91.2666C201.06 96.2857 184.077 100.726 165.84 101.245L165.425 109.928Z",
    fill: "#9A9A9A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.3968 5.68697C73.5529 4.99739 70.0663 5.54707 68.8716 6.29923C68.8716 21.4723 84.4584 31.6139 106.277 31.6139C128.096 31.6139 143.509 21.64 143.509 6.46696C142.25 5.21881 138.177 5.09879 136.768 5.59992C135.834 17.817 124.366 24.3702 106.526 24.3702C88.7299 24.3702 77.3706 17.847 76.3968 5.68697Z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.87266,
    y1: 185.298,
    x2: 222.127,
    y2: -8.7015,
    stroke: "#D82626",
    strokeWidth: 15
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_725_49769"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 213,
    height: 181,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleeves0);
export default __webpack_public_path__ + "static/media/Sleeves 0.437d8610d6628444e6ef298357fbb41e.svg";
export { ForwardRef as ReactComponent };